{
  "version": 1,
  "asset_id": "8905d0cb-ee0a-4cdf-b3cc-84a636787142",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/8905d0cb-ee0a-4cdf-b3cc-84a636787142/beverly-hills-shingle-roof-tear-off-480w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/8905d0cb-ee0a-4cdf-b3cc-84a636787142/beverly-hills-shingle-roof-tear-off-480w.avif",
  "original_filename": "beverly-hills-shingle-roof-tear-off-480w.avif",
  "size": 16531,
  "content_type": "image/avif",
  "created_at": "2026-07-29T14:06:44Z"
}
